<template>
  <div class="score-tag" :class="{
    correct: interactionMeta.isAnswerCorrect && !interaction.config.hide_correct_answer_always,
    incorrect: !interactionMeta.isAnswerCorrect && !interaction.config.hide_correct_answer_always,
    ungraded: ungradedAttempt,
    noPoints: noPoints,
    'py-2': sidebarStyle === 'portrait',
    'py-3': sidebarStyle !== 'portrait',
    }">
    <!-- points -->
    <div v-if="showScore && !bulb.config.score_disabled && !ungradedAttempt && interactionAttempt.pointsAvailable > 0" 
      :aria-label="`interaction points earned ${interactionAttempt.pointsEarned} out of ${interactionAttempt.pointsAvailable}`">
      {{interactionAttempt.pointsEarned}} / {{interaction.pointsAvailable}} pts
    </div>
    <!-- points tooltip -->
    <v-tooltip v-if="!bulb.config.score_disabled && ungradedAttempt && interactionAttempt.pointsAvailable > 0" top>
      <p slot="activator" aria-label="points earned">* / {{interaction.pointsAvailable}} pts</p>
      <span>Grade Pending</span>
    </v-tooltip>
    <!-- score icon -->
    <div v-if="bulb.config.score_disabled || !interactionAttempt.pointsAvailable || interaction.config.hide_correct_answer_always">
      <v-icon v-if="hideAnswerAlwaysEnabled">check_circle</v-icon>
      <v-icon v-else>{{interactionMeta.isAnswerCorrect ? 'check_circle' : 'highlight_off'}}</v-icon>
      <span class="screen-reader-tag">interaction graded {{interactionMeta.isAnswerCorrect? 'correct' : 'incorrect'}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'interaction-score',
  components: {  },
  props: [
    'interaction',
    'interactionAttempt',
    'interactionMeta',
  ],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('player', [
      'bulb',
      'sidebarStyle',
    ]),
    noPoints() {
      const interactionType = this.interaction.interactionType;
      const pointsAvailable = this.interaction.pointsAvailable;
      return (pointsAvailable === 0 && interactionType === 'free_response') || (this.hideAnswerAlwaysEnabled && ['check_all_apply', 'multiple_choice'].includes(interactionType));
    },
    ungradedAttempt() {
      if ( // if a free response interaction has 0 pointsAvailable the interactionAttempt will have null for pointsEarned when submitted and is considered graded
        this.interaction.interactionType === 'free_response' 
        && this.interaction.pointsAvailable === 0
        && _.get(this.interactionAttempt, 'completed', 0) === 1
      ) return false; 
      // otherwise check if they have an interactionAttempt that has null for pointsEarned, autograded interactions will already fill this during grading
      return _.get(this.interactionAttempt, 'pointsEarned', null) === null;
    },
    showScore() {
      if (['multiple_choice', 'check_all_apply', 'short_answer'].includes(this.interaction.interactionType)) {
        if (_.get(this, 'interaction.config.hide_correct_answer_always', false)) return false;
        if (
          _.get(this, 'interaction.config.show_highlighting_last_attempt_only', false)
          && (this.interactionMeta.attempts < this.interaction.attempts)
          && !this.interactionMeta.isAnswerCorrect
        ) return false;
      }
      return true;
    },
    hideAnswerAlwaysEnabled() {
      return _.get(this, 'interaction.config.hide_correct_answer_always', false);
    },
    showHighlighting() {
      return _.get(this, 'interaction.config.show_highlighting_last_attempt_only', false);
    },
    lastAttempt() {
      return (this.interactionMeta.attempts >= this.interaction.attempts);
    },
  },
};
</script>

<style>
  .score-tag.correct, .score-tag.correct i {
	  color: #4caf50!important
  }
  .score-tag.incorrect, .score-tag.incorrect i {
  	color: #f44336;
  }
  .score-tag.ungraded, .score-tag.ungraded i {
    color: #ef6c01!important;
  }
  .score-tag.noPoints, .score-tag.noPoints i {
    color: #2196F3!important;
  }
  .score-tag{
    font-size: 12px;
    color: #409eff;
    border-radius: 4px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    float: left;
  }
</style>
